import React, { useState } from "react";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "What does WhatsApp automation mean?",
      answer:
        "WhatsApp automation refers to the use of technology to automatically send, receive, and manage messages on WhatsApp. It helps businesses handle customer inquiries, send updates, promotions, and reminders without manual effort, saving time and improving communication efficiency.",
    },
    {
      question: "How does WhatsApp bulk messaging work?",
      answer:
        "WhatsApp bulk messaging allows businesses to send a single message to multiple contacts at once. It is commonly used for announcements, offers, event notifications, and important updates, ensuring quick and consistent communication with a large audience.",
    },
    {
      question: "Is sending bulk messages on WhatsApp allowed?",
      answer:
        "Bulk messaging is permitted only when it follows WhatsApp’s official policies. Messages must be sent using approved WhatsApp Business APIs, and recipients should have given their consent. Sending unsolicited or spam messages can lead to account restrictions or bans.",
    },
    {
      question: "Can WhatsApp messages be automated for business use?",
      answer:
        "Yes, businesses can automate WhatsApp messages using tools like chatbots and workflows. Automation can handle FAQs, order confirmations, appointment reminders, and customer support queries, helping businesses respond faster and operate more efficiently.",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="w-full bg-white flex flex-col py-12">
      <div className="w-full lg:w-1/2 mx-auto px-4">
        <h2 className="text-center text-black text-xl md:text-3xl font-semibold mb-8">
          Frequently Asked Questions
        </h2>

        {faqs.map((faq, index) => {
          const isOpen = openIndex === index;

          return (
            <div
              key={index}
              onClick={() => toggleFAQ(index)}
              className="bg-[#F1F5F5] rounded-xl px-5 py-5 mb-4 cursor-pointer"
            >
              <div className="flex justify-between items-center">
                <p
                  className={`text-base md:text-lg text-[#0C4D45] ${
                    isOpen ? "font-semibold" : "font-normal"
                  }`}
                >
                  {faq.question}
                </p>

                {isOpen ? (
                  <FiChevronUp className="w-5 h-5 text-black" />
                ) : (
                  <FiChevronDown className="w-5 h-5 text-black/80" />
                )}
              </div>

              {isOpen && (
                <p className="text-sm text-[#262728] mt-3 leading-relaxed">
                  {faq.answer}
                </p>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FaqSection;
